export function occurrencesOf(type: string, licenses: Array<string>) {
    return licenses.reduce((counter, licenseType) => {
        if (licenseType) {
            return type === licenseType?.toLowerCase() ? counter + 1 : counter
        }
        return counter
    }, 0)
}